//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'BurnNutrition',
  data() {
    return {
      form: {
        burned: '',
        height: '',
        weight: '',
      },
      hasScore: false,
      disabled: false
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        // 体表面积（m2）=0.0061*身高（cm）＋0.0128*体重（kg）－0.1529
        // 患者所需热能（KJ/d）=4184*体表面积（m2）＋105*烧伤面积（%）
        let bsa = 0.0061 * form.height + 0.0128 * form.weight - 0.1529
        let result = 4184 * bsa + 104.6 * form.burned
        self.hasScore = true
        return String(result.toFixed(1))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/BurnNutrition.vue